// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"82923997","650":"c7f2edf8","676":"91bf010f"}[chunkId] + ".chunk.js";
};